/* 🤖 this file was generated by script */
export const wiconFile01 = {
  name: 'file_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6.8c0-1.68 0-2.52.33-3.16a3 3 0 011.3-1.31C6.29 2 7.13 2 8.8 2h6.4c1.68 0 2.52 0 3.16.33a3 3 0 011.31 1.3c.33.65.33 1.49.33 3.17v10.4c0 1.68 0 2.52-.33 3.16a3 3 0 01-1.3 1.31c-.65.33-1.49.33-3.17.33H8.8c-1.68 0-2.52 0-3.16-.33a3 3 0 01-1.31-1.3C4 19.71 4 18.87 4 17.2V6.8z"/></svg>`,
};
